
import React, { useEffect } from 'react';
import Index from './Index';
import { useAuth } from '@/context/AuthContext';
import { supabase } from '@/integrations/supabase/client';
import { invokeFunction } from '@/lib/utils/invokeFunction';

const Home = () => {
  const { profile, user } = useAuth();

  useEffect(() => {
    const checkCreditReset = async () => {
      // If no profile, return early
      if (!profile?.id) return;

      // Check if we've already shown the toast this session
      const sessionKey = `credit_reset_shown_${profile.id}`;
      if (sessionStorage.getItem(sessionKey)) return;
      
      try {
        const { data, error } = await supabase
          .from("profiles")
          .select("credit_reset_date")
          .eq("id", profile.id)
          .maybeSingle();

        if (error) {
          return;
        }

        if (data?.credit_reset_date) {
          const creditResetDate = new Date(data.credit_reset_date);
          const now = new Date();
          
          if (creditResetDate <= now) {
            const { error: refreshError } = await invokeFunction('refresh-free-credits');
            
            if (!refreshError) {
              // Just set the session flag without showing toast
              sessionStorage.setItem(sessionKey, 'true');
            }
          }
        }
      } catch (err) {
        // Error handling without console.log
      }
    };

    checkCreditReset();
  }, [profile]); 

  return <Index />;
};

export default Home;
